import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-olive text-cream overflow-hidden pt-10 pb-16 md:pt-16 md:pb-20 px-4" data-id="element-157">
      {/* Subtle background texture/glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(197,165,90,0.15),transparent_50%)]" data-id="element-158" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(26,26,26,0.4),transparent_50%)]" data-id="element-159" />

      <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-3" data-id="element-161">
          <span className="inline-block border border-gold/50 text-gold px-4 py-1.5 rounded-full text-sm font-semibold tracking-widest uppercase mb-4" data-id="element-162">
            Intimidad Radical
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold leading-tight text-balance mb-4" data-id="element-163">
            ¿Y Si el Silencio de Dios No Es Abandono...{' '}
            <span className="text-gold italic" data-id="element-164">Sino una Invitación?</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-3xl mx-auto mb-10" data-id="element-165">
          <p className="text-lg md:text-xl text-cream/90 leading-relaxed" data-id="element-166">
            Descubre el Protocolo de 30 Días que Está Ayudando a Miles de
            Creyentes Agotados a Pasar de la Religión de Domingo a Caminar con
            Jesús Como un Amigo Real — Sin Más Culpa, Sin Más Fórmulas Vacías,
            Sin Más Monólogos que Rebotan en el Techo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="relative w-full max-w-2xl mx-auto" data-id="element-167">
          <div className="absolute -inset-4 bg-gold/20 blur-2xl rounded-full opacity-50" data-id="element-168" />
          <img src="https://cdn.magicpatterns.com/uploads/v15xEYow1PmQWHm5cEiBez/INTIMIDAD_RADICAL_1.png" alt="Intimidad Radical Ebook on Tablet" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border border-gold/20" data-id="element-169" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-10 flex flex-col items-center gap-3" data-id="element-170">
          <CTAButton data-id="element-171" />
          <p className="text-cream/50 text-xs tracking-wide" data-id="element-172">
            Producto digital en PDF · Pago único · Entrega inmediata
          </p>
        </motion.div>
      </div>
    </section>;
}